import { Outlet } from 'react-router-dom';
import { Message } from '../../../components/message/message';
import { Slider } from '../../../components/slider/slider';
import { AlertContainer } from '../../../features/alert/alert-container/alert-container';
import { useLang } from '../../../hooks/use-lang';
import s from './auth.module.css';

const slides: { id: string; title: string; description: string }[] = [
  {
    id: '1',
    title: 'С возвращением!',
    description:
      'Мы рады приветствовать Вас на нашем ресурсе, для использования самой крутой информационной жизни, пожалуйста, пройдите регистрация',
  },
  {
    id: '2',
    title: 'Работайте командой сообща!',
    description:
      'Организуйте Ваш бизнес вместе с informer.center, самая удобная система коммуникации бизнеса и Вашей ЦА! Только не забудьте авторизоваться )',
  },
  {
    id: '3',
    title: 'Пусть этот день будет лучшим для Вас!',
    description:
      'Использование системы обязательно сделает Ваш день лучшим, только не забудьте авторизоваться!',
  },
];

export const Auth = () => {
  const { t } = useLang();

  return (
    <div className={s.page}>
      <Slider className={s.ads} intervalMs={5000}>
        {slides.map(({ description, id, title }) => (
          <div className={s.item} key={id}>
            <Message
              description={t(description)}
              label={t(title)}
              className={s.message}
              variant="ghost"
            />
          </div>
        ))}
      </Slider>
      <div className={s.wrapper}>
        <Outlet />
      </div>
      <AlertContainer />
    </div>
  );
};
